import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'index',
    component: () => import("@/views/IndexView.vue"),

    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/home/HomeView.vue')
      },
      {
        path: '/about-platform',
        name: 'about-platform',
        component: () => import('@/views/about-platform/PlatformView.vue')
      }, {
        path: "/carbon-disclosure",
        name: 'carbon-disclosurem',
        component: () => import('@/views/carbon-disclosure/carbonDisclosure.vue')
      },
      {
        path: "/esg-rating",
        name: 'esg-rating',
        component: () => import('@/views/esg-rating/EsgRating.vue')
      },
      {
        path: "/esg-search",
        name: 'esg-search',
        component: () => import('@/views/esg-rating/EsgSearch.vue')
      },
      {
        path: "/esg-contrast",
        name: 'esg-contrast',
        component: () => import('@/views/esg-rating/EsgContrast.vue')
      },
      {
        path: "/overseas-orders",
        name: 'overseas-orders',
        component: () => import('@/views/overseas-orders/overseasOrders.vue')
      },
      {
        path: "/green-finance",
        name: 'green-finance',
        component: () => import('@/views/green-finance/greenFinance.vue')
      },
      {
        path: "/carbon-subsidy",
        name: 'carbon-subsidy',
        component: () => import('@/views/carbon-subsidy/carbonSubsidy.vue')
      }
      ,
      {
        path: "/resources",
        name: 'resources',
        component: () => import('@/views/resources/resourcesView.vue')
      },
      {
        path: "/partner",
        name: 'partner',
        component: () => import('@/views/partner/partnerView.vue')
      },
      {
        path: "/stock-esg-rating",
        name: 'stock-esg-rating',
        component: () => import('@/views/stock-esg-rating/StockEsgRating.vue')
      }
    ]
  },
  // 404重定向到首页
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  },
  
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  // 配置滚动行为
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
  }
})

export default router
